import React, { useEffect, useState } from 'react';
import { Check, Gift, ShoppingCart, Clock, Users, Download, ShieldCheck, ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
function CountdownTimer() {
  const [seconds, setSeconds] = useState(15 * 60);
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(s => s <= 1 ? 15 * 60 : s - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const mins = String(Math.floor(seconds / 60)).padStart(2, '0');
  const secs = String(seconds % 60).padStart(2, '0');
  return <div className="bg-red-600 text-white rounded-xl p-4 mb-6 text-center" data-id="element-150">
      <p className="text-sm font-semibold uppercase tracking-wide mb-2 opacity-90" data-id="element-151">
        Últimos minutos para que el descuento esté activo
      </p>
      <div className="flex items-center justify-center gap-2" data-id="element-152">
        <div className="bg-red-800 rounded-lg px-4 py-2 min-w-[56px] text-center" data-id="element-153">
          <span className="text-3xl font-extrabold tabular-nums" data-id="element-154">{mins}</span>
          <p className="text-xs opacity-75 mt-0.5" data-id="element-155">MIN</p>
        </div>
        <span className="text-3xl font-extrabold" data-id="element-156">:</span>
        <div className="bg-red-800 rounded-lg px-4 py-2 min-w-[56px] text-center" data-id="element-157">
          <span className="text-3xl font-extrabold tabular-nums" data-id="element-158">{secs}</span>
          <p className="text-xs opacity-75 mt-0.5" data-id="element-159">SEG</p>
        </div>
      </div>
    </div>;
}
const bonusSummary = [{
  title: 'El Ritual 7×1 (Starter Kit)',
  image: 'https://cdn.magicpatterns.com/uploads/qojd7ppLZJzCA1AcsA5WFN/El-Ritual-71-Starter-Kit.png',
  value: '$890',
  description: 'Todo lo que necesitás para arrancar hoy: guía paso a paso, checklist, tracker de 7 días y tarjeta de heladera con tus 3 reglas diarias.',
  quote: 'Si es fácil, se sostiene. Este kit existe para que no haya excusa el Día 1.'
}, {
  title: 'Guía de Señales Silenciosas',
  image: 'https://cdn.magicpatterns.com/uploads/5FUU7LAuS9NjgnP1JSwzAp/Tu-cuerpo-avisa-en-silencio-antes-de-gritar.png',
  value: '$590',
  description: 'Aprendé a leer las 3 ventanas del día (mañana, post-comida, noche) para saber si lo que sentís es una señal de alerta o solo ruido. Incluye semáforo visual y guion para hablar con tu médico.',
  quote: 'Cuando escuchás temprano, evitás el susto tarde.'
}, {
  title: 'Kit Anti-Picos Express',
  image: 'https://cdn.magicpatterns.com/uploads/mGWupp33G59swixDCTAQmw/Kit-Anti-Picos-Express-Post-Comida-en-10-Min.png',
  value: '$410',
  description: 'Un protocolo de 10 minutos para después de una comida pesada. Tres versiones: casa, trabajo y asado. Sin gimnasio, sin pastillas, sin irse de la mesa.',
  quote: 'No cambies tu comida hoy. Cambiá lo que hacés después.'
}];
export function OfferSection() {
  const [expandedBonus, setExpandedBonus] = useState<number | null>(null);
  const toggleBonus = (idx: number) => {
    setExpandedBonus(expandedBonus === idx ? null : idx);
  };
  return <section id="offer" className="py-16 px-4 bg-emerald-50" data-id="element-160">
      <div className="max-w-5xl mx-auto" data-id="element-161">
        <div className="text-center mb-10" data-id="element-162">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-163">
            Lo Que Recibe Hoy
          </h2>
          <p className="text-xl text-gray-600" data-id="element-164">
            El Protocolo Completo de Limpieza Glicémica de 7 Días
          </p>
        </div>

        <Card variant="highlight" className="max-w-3xl mx-auto relative" data-id="element-165">
          <div className="absolute top-0 right-0 bg-red-600 text-white px-4 py-1 rounded-bl-lg font-bold text-sm uppercase" data-id="element-166">
            50% Descuento
          </div>

          <div className="p-8 md:p-12" data-id="element-167">
            <div className="flex flex-col md:flex-row gap-8 items-center mb-8" data-id="element-168">
              <div className="w-full md:w-1/3" data-id="element-169">
                <img src="https://cdn.magicpatterns.com/uploads/swco9uh88fgzGaxD6EYQFz/Mockup.png" alt="Pack Completo" className="w-full rounded-lg shadow-md" data-id="element-170" />
              </div>
              <div className="w-full md:w-2/3" data-id="element-171">
                <h3 className="text-2xl font-bold text-emerald-800 mb-4" data-id="element-172">
                  El Protocolo de Limpieza Glicémica
                </h3>
                <ul className="space-y-3 mb-6" data-id="element-173">
                  <li className="flex items-start" data-id="element-174">
                    <Check className="h-5 w-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-175" />
                    <span className="text-gray-700" data-id="element-176">
                      <strong data-id="element-177">La Guía de las 7 Hierbas Maestras</strong> (valor
                      $1.200)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-178">
                    <Check className="h-5 w-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-179" />
                    <span className="text-gray-700" data-id="element-180">
                      <strong data-id="element-181">El Truco del Post-Asado</strong> (valor $500)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-182">
                    <Check className="h-5 w-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-183" />
                    <span className="text-gray-700" data-id="element-184">
                      <strong data-id="element-185">La Técnica del Movimiento Invisible</strong>{' '}
                      (valor $400)
                    </span>
                  </li>
                </ul>
                <div className="bg-emerald-100 p-4 rounded-lg flex items-center gap-3" data-id="element-186">
                  <Gift className="h-6 w-6 text-emerald-700" data-id="element-187" />
                  <p className="text-sm text-emerald-800 font-medium" data-id="element-188">
                    Incluye acceso de por vida y actualizaciones futuras gratis.
                  </p>
                </div>
              </div>
            </div>

            <div className="border-t border-gray-200 pt-6 mb-6" data-id="element-189">
              <div className="flex items-center gap-2 mb-4" data-id="element-190">
                <Gift className="h-5 w-5 text-emerald-600" data-id="element-191" />
                <h4 className="font-bold text-gray-900" data-id="element-192">
                  + 3 Bonos incluidos GRATIS (valor $1.890 UYU)
                </h4>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-193">
                {bonusSummary.map((bonus, idx) => <div key={idx} className="bg-white rounded-lg border border-gray-200 overflow-hidden flex flex-col" data-id="element-194">
                    <div className="p-3 flex flex-col items-center text-center" data-id="element-195">
                      <img src={bonus.image} alt={bonus.title} className="w-full h-24 object-cover rounded-md mb-2" data-id="element-196" />
                      <p className="text-xs font-bold text-gray-900 mb-1" data-id="element-197">
                        {bonus.title}
                      </p>
                      <div className="flex items-center gap-1.5 mb-2" data-id="element-198">
                        <span className="text-xs text-gray-400 line-through" data-id="element-199">
                          {bonus.value}
                        </span>
                        <span className="text-xs font-bold text-emerald-700" data-id="element-200">
                          GRATIS
                        </span>
                      </div>
                      <button onClick={() => toggleBonus(idx)} className="flex items-center gap-1 text-emerald-700 hover:text-emerald-800 text-xs font-semibold transition-colors" data-id="element-201">
                        {expandedBonus === idx ? <>
                            Leer menos <ChevronUp className="h-3.5 w-3.5" data-id="element-202" />
                          </> : <>
                            Leer más <ChevronDown className="h-3.5 w-3.5" data-id="element-203" />
                          </>}
                      </button>
                    </div>

                    {expandedBonus === idx && <div className="border-t border-gray-100 bg-gray-50 p-3" data-id="element-204">
                        <p className="text-xs text-gray-700 leading-relaxed mb-2" data-id="element-205">
                          {bonus.description}
                        </p>
                        <div className="bg-emerald-50 text-emerald-800 p-2 rounded text-xs italic border-l-3 border-emerald-500" data-id="element-206">
                          "{bonus.quote}"
                        </div>
                      </div>}
                  </div>)}
              </div>
            </div>

            <div className="border-t border-gray-200 pt-8" data-id="element-207">
              <CountdownTimer data-id="element-208" />

              <div className="flex items-center justify-center gap-2 bg-amber-50 border border-amber-300 rounded-xl p-3 mb-6" data-id="element-209">
                <Users className="h-5 w-5 text-amber-600 flex-shrink-0" data-id="element-210" />
                <p className="text-amber-800 font-bold text-sm md:text-base" data-id="element-211">
                  Últimos 3 cupos disponibles al precio de oferta
                </p>
              </div>

              <div className="text-center mb-6" data-id="element-212">
                <p className="text-gray-500 line-through text-xl mb-1" data-id="element-213">
                  Precio Normal: $580 UYU
                </p>
                <div className="flex items-center justify-center gap-3 mb-1" data-id="element-214">
                  <span className="text-5xl md:text-6xl font-extrabold text-gray-900" data-id="element-215">
                    $290
                  </span>
                  <span className="text-2xl font-bold text-gray-600" data-id="element-216">UYU</span>
                  <span className="bg-red-100 text-red-700 text-sm font-bold px-2 py-1 rounded-lg" data-id="element-217">
                    -50%
                  </span>
                </div>
                <p className="text-emerald-700 font-semibold text-sm" data-id="element-218">
                  Precio especial de lanzamiento
                </p>
              </div>

              <div className="flex items-center justify-center gap-2 mb-6 text-gray-600 text-sm" data-id="element-219">
                <Download className="h-4 w-4 text-emerald-600" data-id="element-220" />
                <span className="font-semibold text-emerald-700" data-id="element-221">
                  +1.400 descargas
                </span>
                <span className="text-gray-400" data-id="element-222">·</span>
                <span className="font-semibold" data-id="element-223">4.9/5 promedio</span>
              </div>

              <Button size="xl" fullWidth className="max-w-md mx-auto mb-4 shadow-xl text-lg" data-id="element-224">
                <ShoppingCart className="mr-2 h-6 w-6" data-id="element-225" />
                SÍ, QUIERO MI PROTOCOLO AHORA
              </Button>

              <div className="flex justify-center gap-4 text-xs text-gray-500 mb-6" data-id="element-226">
                <span data-id="element-227">Pago 100% Seguro</span>
                <span data-id="element-228">Descarga Inmediata</span>
                <span data-id="element-229">Envío por Email</span>
              </div>

              <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4 flex items-start gap-3 text-left" data-id="element-230">
                <ShieldCheck className="h-6 w-6 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-231" />
                <div data-id="element-232">
                  <p className="font-bold text-emerald-900 text-sm" data-id="element-233">
                    Garantía de 7 días
                  </p>
                  <p className="text-emerald-800 text-xs mt-1" data-id="element-234">
                    Si no ve resultados, le devolvemos cada peso. Sin preguntas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </section>;
}